<style scoped lang="scss">
.log-wrapper {
    background: #f5f6f8;
    min-height: 100vh;
    padding: 1.25rem;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.25rem;

    h2 {
        font-size: 1.125rem;
        font-weight: 600;
        color: #1a1d21;
        margin: 0;
    }
}

.table-section {
    background: #fff;
    border: 1px solid #e8eaed;
    border-radius: 10px;
    overflow: hidden;

    .table-scroll {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        padding: 1.25rem 1rem;

        &::-webkit-scrollbar {
            height: 6px;
        }

        &::-webkit-scrollbar-track {
            background: #f5f6f8;
            border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
            background: #c5c8ce;
            border-radius: 3px;

            &:hover {
                background: #a0a5ad;
            }
        }
    }

    .log-table {
        width: 100%;
        min-width: 800px;
        border-collapse: collapse;
        font-size: 0.875rem;

        th {
            background: #fafbfc;
            padding: 0.5625rem 0.75rem;
            text-align: left;
            font-weight: 600;
            color: #5c5f66;
            border-bottom: 1px solid #e8eaed;
            white-space: nowrap;
            font-size: 0.8125rem;
            text-transform: uppercase;
            letter-spacing: 0.03em;

            &:nth-child(1) {
                width: 60px;
            }

            &:nth-child(2) {
                width: 100px;
            }

            &:nth-child(3) {
                width: auto;
            }

            &:nth-child(4) {
                width: 100px;
            }

            &:nth-child(5) {
                width: 100px;
            }

            &:nth-child(6) {
                width: 100px;
            }

            &:nth-child(7) {
                width: 160px;
            }
        }

        td {
            padding: 0.6875rem 0.75rem;
            color: #1a1d21;
            border-bottom: 1px solid #f0f1f3;
            vertical-align: middle;
        }

        tr:last-child td {
            border-bottom: none;
        }

        tr:hover td {
            background: #fafbfc;
        }
    }

    .table-footer {
        display: flex;
        justify-content: center;
        padding: 0.875rem 1rem;
        border-top: 1px solid #f0f1f3;
    }
}

.status-badge {
    display: inline-block;
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
    font-weight: 600;
    border-radius: 4px;
    letter-spacing: 0.02em;

    &.status-income {
        background: #d4edda;
        color: #1b5e3b;
    }

    &.status-expense {
        background: #f8d7da;
        color: #8b1a1a;
    }

    &.status-login {
        background: #cce5ff;
        color: #0c5460;
    }

    &.status-other {
        background: #e2e3e5;
        color: #383d41;
    }

    &.status-author {
        background: #d1ecf1;
        color: #0c5460;
    }
}

.money-text {
    font-weight: 600;
    font-family: 'SF Mono', 'Monaco', 'Consolas', monospace;

    &.money-income {
        color: #059669;
    }

    &.money-expense {
        color: #dc2626;
    }

    &.money-before {
        color: #d97706;
    }

    &.money-after {
        color: #2563eb;
    }

    &.money-none {
        color: #a0a5ad;
        font-weight: 400;
    }
}

:deep(.el-pagination) {
    .el-pagination__total {
        font-size: 0.75rem;
        color: #8c9199;
    }

    .btn-prev,
    .btn-next {
        background: #fff;
        border: 1px solid #e0e2e5;
        border-radius: 4px;

        &:hover {
            background: #f5f6f8;
        }
    }

    .el-pager li {
        background: #fff;
        border: 1px solid #e0e2e5;
        border-radius: 4px;
        font-size: 0.75rem;
        min-width: 1.75rem;
        height: 1.75rem;
        line-height: 1.75rem;

        &:hover {
            background: #f5f6f8;
        }

        &.is-active {
            background: #1a1d21;
            color: #fff;
            border-color: #1a1d21;
        }
    }
}
</style>
<template>
    <div class="common-layout">
        <el-container>
            <el-aside style="width: fit-content;">
                <UserHead />
            </el-aside>
            <el-container>
                <el-header style="padding: 0;">
                    <HeadTop />
                </el-header>
                <el-main
                    style="padding-top: 0;height:100vh;padding-left: 0;background-color: #f5f6f8 !important;overflow: auto;">
                    <div class="log-wrapper">
                        <div class="container">
                            <div class="table-section">
                                <div class="table-scroll">
                                    <table class="log-table">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>日志类型</th>
                                                <th>内容</th>
                                                <th>交易后余额</th>
                                                <th>交易前余额</th>
                                                <th>操作金额</th>
                                                <th>时间</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="row in log_data" :key="row.id">
                                                <td>{{ row.id }}</td>
                                                <td>
                                                    <span class="status-badge" :class="{
                                                        'status-income': row.log_act == 1 || row.log_act == 5,
                                                        'status-expense': row.log_act == 2,
                                                        'status-login': row.log_act == 3,
                                                        'status-other': row.log_act == 4,
                                                        'status-author': row.log_act == 5
                                                    }">{{ getLogAct(row.log_act) }}</span>
                                                </td>
                                                <td>{{ row.log_desc }}</td>
                                                <td>
                                                    <span
                                                        :class="['money-text', row.afterMoney != undefined ? 'money-after' : 'money-none']">
                                                        {{ row.afterMoney != undefined ? row.afterMoney : '无' }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span
                                                        :class="['money-text', row.beforeMoney != undefined ? 'money-before' : 'money-none']">
                                                        {{ row.beforeMoney != undefined ? row.beforeMoney : '无' }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span :class="['money-text',
                                                        row.operationMoney != undefined
                                                            ? (row.log_act == 2 ? 'money-expense' : 'money-income')
                                                            : 'money-none'
                                                    ]">
                                                        {{ row.operationMoney != undefined
                                                            ? (row.log_act == 2 || row.log_act == 4
                                                                ? '-' + row.operationMoney + '元'
                                                                : '+' + row.operationMoney + '元')
                                                            : '无' }}
                                                    </span>
                                                </td>
                                                <td>{{ row.add_time }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="table-footer">
                                    <el-pagination v-model:current-page="log_Conf.currentPage"
                                        v-model:page-size="log_Conf.pageSize" :page-sizes="[10, 25, 50]"
                                        layout="total, sizes, prev, pager, next, jumper" :total="log_Conf.total"
                                        @size-change="logSizeChange" @current-change="logCurrentChange" />
                                </div>
                            </div>
                        </div>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { ElMessage } from 'element-plus'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        UserHead,
        HeadTop
    },
    data() {
        return {
            log_Conf: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            log_data: []
        }
    }, methods: {
        getLogAct(act) {
            switch (act) {
                case 1:
                    return "收入"
                case 2:
                    return "支出"
                case 3:
                    return "登录"
                case 4:
                    return "其他"
                case 5:
                    return "作者收入"
                default:
                    return "未知"
            }
        },
        getUserLog() {
            openLoading()
            const data = new FormData();
            data.append("page", this.log_Conf.currentPage)
            data.append("pageSize", this.log_Conf.pageSize)
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.post(baseURL + '/userApi/getUserLog', data, { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 401) {
                        ElMessage.error(res.data.msg)
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                        return
                    }
                    if (res.data.code == 200) {
                        this.log_data = res.data.data
                        this.log_Conf.total = res.data.total
                        return;
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        logSizeChange(val) {
            this.log_Conf.pageSize = val
            this.getUserLog()
        },
        logCurrentChange(val) {
            this.log_Conf.currentPage = val
            this.getUserLog()
        },
    },
    mounted() {
        this.getUserLog()
    }
})
</script>